import styled, { css } from 'styled-components'

const StyledButton = styled.button`
  border: none;
  &:focus {
    outline: none;
  }
  cursor: pointer;
  pointer-events: auto;
  vertical-align: baseline;
  min-width: ${({ minW }) => minW || `270px`};
  font-size: 21px;
  border-radius: ${({ square }) => (square ? '8px' : '27px')};
  padding: 10px 21px;
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica,
    Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol' !important;
  ${({ size }) =>
    size === 2 ? `min-width: 180px; height: 60px; border-radius: 33px;` : ``}
  background-color: ${({ inverse, theme }) =>
    inverse ? theme.colors.light1 : theme.colors.primary};
  background-color: ${({ bgColor, theme }) =>
    bgColor || theme.colors.buttonDefault};
  ${({ textColor }) => textColor && `color: ${textColor}!important;`}
  color: ${({ inverse, theme, textColor }) =>
    inverse ? theme.colors.primary : theme.colors.light1};

  ${({ secondary, theme }) =>
    secondary &&
    css`
      background-color: transparent;
      color: ${theme.colors.primary};
      border: 1px solid ${theme.colors.primary};
    `}
  @media only screen and (max-width: 600px) {
    font-size: 17px;
    ${({ minW }) => minW || `240px`};
  }
  transition: background-color ease 0.3s, filter ease 0.3s;

  &:hover {
    ${({ inverse, theme }) =>
      inverse
        ? `background-color: ${theme.colors.secondary};`
        : `filter: saturate(1.8);`}
  }
`

export default StyledButton
